import { useLocation } from 'react-router-dom'
import { InstitutionBillingView } from '@/components/Billing/InstitutionBillingView'
import { StandaloneTopBar } from '@/components/Layout/StandaloneTopBar'

export default function Billing() {
  const location = useLocation()
  const isStandalone = location.pathname === '/billing'

  if (!isStandalone) return <InstitutionBillingView />

  return (
    <div className="min-h-screen w-full bg-background">
      <StandaloneTopBar backTo="/dashboard" backLabel="Back to Dashboard" />
      <InstitutionBillingView />
    </div>
  )
}
